// extracted by mini-css-extract-plugin
export var iframe = "gen-video-module--iframe--szY8g";